export enum SearchSortDirectionEnum {

    ASC = 'ASC',
    DESC = 'DESC'

}